import type { FieldDefinition } from '../data/model';

export type AttributeRuleFieldKind = 'boolean' | 'number' | 'string';

export function attributeRuleFieldKind(field: FieldDefinition): AttributeRuleFieldKind | null {
  switch (field.type) {
    case 'boolean':
      return 'boolean';
    case 'integer':
    case 'number':
      return 'number';
    case 'string':
      return 'string';
    case 'date':
    case 'array':
    case 'mixed':
    case 'object':
    case 'unknown':
      return null;
  }
}

export function attributeRuleFields(
  fields: readonly FieldDefinition[],
): readonly FieldDefinition[] {
  return fields.filter((field) => attributeRuleFieldKind(field) !== null);
}

export function attributeRuleField(
  fields: readonly FieldDefinition[],
  fieldName: string,
): FieldDefinition | null {
  return (
    fields.find((field) => field.name === fieldName && attributeRuleFieldKind(field) !== null) ??
    null
  );
}
